import { IApplicationContext } from 'shared/types/applicationContext';
import { createReferrerReduxStore } from 'shared/utils/redux';
import { TApplicationState, TReduxStore } from '../../../shared/types/referrer/store';

export function createReferrerApplicationState(context: IApplicationContext): TReduxStore {
  const { config } = context;

  const initialState = config.getStrict<TApplicationState>('initialState');

  return createReferrerReduxStore(context, initialState, true);
}
